import React from 'react';

interface PrimaryButtonLightProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}

const PrimaryButtonLight: React.FC<PrimaryButtonLightProps> = ({
  children,
  className = '',
  ...props
}) => {
  return (
    <button
      className={`px-4 py-2 bg-slate-200 hover:bg-slate-300 text-slate-800 rounded-md text-sm transition-colors ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default PrimaryButtonLight;
